module.exports = __webpack_public_path__ + "img/waterDrop.1ebfbd90.svg";